var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSerious(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Serious",
    transform: "translate(-1693 -564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_691",
    "data-name": "Ellipse 691",
    transform: "translate(1693 564)",
    fill: "none",
    stroke: "#ef3f4e",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11648",
    "data-name": "Path 11648",
    d: "M855.584,46.621a1.623,1.623,0,1,0-1.133-.483A1.621,1.621,0,0,0,855.584,46.621Z",
    transform: "translate(846.381 531.424)",
    fill: "#ef3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11649",
    "data-name": "Path 11649",
    d: "M861.7,46.7a1.621,1.621,0,1,0-1.147-.475A1.624,1.624,0,0,0,861.7,46.7Z",
    transform: "translate(851.006 531.481)",
    fill: "#ef3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11650",
    "data-name": "Path 11650",
    d: "M859.171,43.056a.852.852,0,0,0,.146.3.831.831,0,0,0,.251.224.854.854,0,0,0,.654.087l2.828-.7a.862.862,0,0,0,.309-.141.831.831,0,0,0,.231-.251.84.84,0,0,0,.114-.321.822.822,0,0,0-.019-.34.876.876,0,0,0-1.052-.636L859.785,42a.844.844,0,0,0-.3.146.858.858,0,0,0-.223.252.854.854,0,0,0-.086.655Z",
    transform: "translate(850.293 529.816)",
    fill: "#ef3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11651",
    "data-name": "Path 11651",
    d: "M856.636,49.965a.9.9,0,0,0,1.053.636l2.849-.723a.837.837,0,0,0,.31-.141.864.864,0,0,0,.232-.251.9.9,0,0,0,.114-.321.855.855,0,0,0-.021-.34.875.875,0,0,0-1.052-.614l-2.849.7a.9.9,0,0,0-.637,1.052Z",
    transform: "translate(848.379 535.073)",
    fill: "#ef3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11652",
    "data-name": "Path 11652",
    d: "M854.727,42.936l2.849.767a.866.866,0,0,0,1.064-.6.863.863,0,0,0-.6-1.063l-2.849-.767h-.373a.882.882,0,0,0-.681.636.856.856,0,0,0,.593,1.052Z",
    transform: "translate(846.473 529.826)",
    fill: "#ef3f4e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerious);
export default __webpack_public_path__ + "static/media/serious.137b66fd260e95ba5f5efd16a73495d3.svg";
export { ForwardRef as ReactComponent };